// export const URL_BACKOFFICE = 'https://backoffice.teamculture.com.br'
// export const URL_BACKOFFICE = 'http://localhost:4000'

export const URL_BACKOFFICE = process.env.VUE_APP_API_BASE_URL

export const TC_SUPPORT_EMAIL = 'tc-suporte@teamculture.com'

export default {
  URL_BACKOFFICE,
  TC_SUPPORT_EMAIL,
}
